const statements = [
  {
    headline: 'Custom Art & Commissions',
    sub: 'Original pieces created entirely around your vision — your colors, your mood, your story. No templates, no shortcuts.',
  },
  {
    headline: 'Completely Unique',
    sub: 'Every work is conceived and created exclusively for you. Once made, it will never be duplicated or reproduced.',
  },
  {
    headline: 'Tailored to You',
    sub: 'Your style, your space, your expression — built into every decision from the very first conversation.',
  },
  {
    headline: 'We create. We don\'t manufacture.',
    sub: 'Each project receives full, undivided artistic attention from start to finish. Quality is never rushed.',
  },
];

const WhyChooseUs = () => (
  <section className="w-full overflow-hidden">
    <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[80vh]">
      {/* Left: real site image */}
      <div className="relative min-h-[50vh] lg:min-h-full order-2 lg:order-1">
        <img
          src="https://images.squarespace-cdn.com/content/v1/6205743531e70503b4cb51e0/a4a287c7-e66b-4c28-a152-7f422ef616eb/boy+fairy+with+red+dragon.jpg"
          alt="Original fantasy art by Deb's Art Designs"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#FAF7F3]/10"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1612]/60 via-transparent to-transparent"></div>
        {/* Floating quote */}
        <div className="absolute bottom-12 left-10 right-10 z-10">
          <div className="border-l-2 border-[#C9A96E]/60 pl-6 py-1">
            <p className="font-serif text-white/85 text-lg italic leading-relaxed mb-2" style={{ fontWeight: 300 }}>
              &ldquo;Every piece is created with intention — no two are ever the same.&rdquo;
            </p>
            <p className="text-[#C9A96E]/70 text-[9px] uppercase tracking-[0.5em] font-light">Deb&apos;s Art Designs</p>
          </div>
        </div>
      </div>

      {/* Right: manifesto on warm ivory */}
      <div className="order-1 lg:order-2 bg-[#FAF7F3] px-10 md:px-16 lg:px-20 py-24 flex flex-col justify-center">
        <div className="flex items-center gap-5 mb-12">
          <div className="w-16 h-px bg-[#C9A96E]/70"></div>
          <span className="text-[#C9A96E] uppercase tracking-[0.5em] text-[9px] font-medium">Why Deb&apos;s Art Designs</span>
        </div>

        <h2 className="font-serif text-[#1A1612] leading-[0.9] tracking-[-0.01em] mb-16" style={{ fontSize: 'clamp(2.5rem, 4vw, 4rem)', fontWeight: 300 }}>
          Art You Can<br />
          <em className="italic text-[#C9A96E]" style={{ fontWeight: 300 }}>Feel</em>
        </h2>

        <div className="flex flex-col">
          {statements.map((s, i) => (
            <div
              key={i}
              className="group border-t border-[#1A1612]/15 py-8 hover:border-[#C9A96E]/40 transition-colors duration-500 cursor-default"
            >
              <h3
                className="font-serif text-[#1A1612] leading-tight mb-0 group-hover:text-[#C9A96E] transition-colors duration-400"
                style={{ fontSize: 'clamp(1.1rem, 2vw, 1.5rem)', fontWeight: 400 }}
              >
                {s.headline}
              </h3>
              <div className="overflow-hidden max-h-0 group-hover:max-h-20 transition-all duration-500">
                <p className="text-[#1A1612]/70 text-sm leading-[1.9] tracking-[0.02em] font-light mt-3 pr-4">{s.sub}</p>
              </div>
            </div>
          ))}
          <div className="border-t border-[#1A1612]/8"></div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
